module.exports = __webpack_public_path__ + "img/scene-2.a19c803.png";